import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

export interface CompareModelsStyleCellProps {
  readonly Icon: SVGIconComponent;
  readonly label: MessageKey;
}

const CompareModelsStyleCell = ({
  Icon,
  label,
}: CompareModelsStyleCellProps) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center gap-3 lg:flex-row lg:gap-4">
      <Icon className="size-14 lg:size-20" />
      <TypographyV3
        className="text-base leading-snug lg:text-2xl"
        Element="span"
      >
        {t(label)}
      </TypographyV3>
    </div>
  );
};

export default CompareModelsStyleCell;
